import { NoopFunction } from '../../types';

/**
 * Executes nothing.
 */
const noop: NoopFunction = () => {};

export default noop;
